import { AxiosService } from './axios.service'
import { SearchService } from './search.service'

/**
 * Defines the API methods for a sale
 */
export class SaleService extends SearchService {
	static baseURL = 'vendas'

	/**
	 * Gets the products
	 * @return {Promise<long>} The list of products
	 */
	static getProducts() {
		return AxiosService.get(`${SaleService.baseURL}/produtos`).then(
			({ data }) => data
		)
	}

	/**
	 * Cancel a sale
	 */
	static cancelSale(params) {
		return AxiosService.post(`cancelamento-de-venda`, params).then(
			({ data }) => data
		)
	}
}
